import qp from 'query-parse';

export function getQuery() {
    return qp.toObject(document.location.search.replace(/^\?/, ''));
}